import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0225add8"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["id"];

const _hoisted_2 = /*#__PURE__*/_createTextVNode("分 享");

import { Toast } from "vant";
import { isWechat } from "../assets/utils/common.utils";
import useClipboard from "vue-clipboard3";
export default {
  __name: 'ShareBtn',
  props: {
    id: {
      default: "",
      type: String
    },
    wxShareMessage: {
      default: "点击页面右上角「···」\n分享给好友吧~",
      type: String
    },
    message: {
      default: "极客公园创新大会 IF2023",
      type: String
    },
    successMessage: {
      default: "链接已复制\n快去分享吧~",
      type: String
    },
    needWXCharge: {
      default: true,
      type: Boolean
    }
  },

  setup(__props) {
    const props = __props;
    const {
      toClipboard
    } = useClipboard();

    const onClick = async () => {
      if (isWechat() && props.needWXCharge) {
        Toast({
          message: props.wxShareMessage,
          duration: 3000
        });
      } else {
        try {
          await toClipboard(props.message);
          Toast.success(props.successMessage);
        } catch (e) {
          Toast.fail("复制失败\n请重试");
          console.error(e);
        }
      }
    };

    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");

      return _openBlock(), _createElementBlock("div", {
        class: "share-btn-component",
        onClick: onClick
      }, [_renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("div", {
        id: __props.id,
        class: "share-icon-btn"
      }, [_createVNode(_component_van_icon, {
        size: "18px",
        name: "share-o"
      }), _hoisted_2], 8, _hoisted_1)])]);
    };
  }

};